<template lang="pug">
SubTitle(v-bind="$props")
  slot
</template>

<script>
import styled from "vue-styled-components"

const Props = {
  weight: String,
  muted: Boolean
}

const SubTitle = styled("h2", Props)`
  font-size: ${props => props.theme.font.large};
  line-height: ${props => props.theme.font.lineHeight};
  opacity: ${props => (props.muted ? 0.7 : 1)};
  font-weight: ${props => (props.weight ? props.theme.font[props.weight] : props.theme.font.light)};
  margin: 0;

  b {
    font-weight: ${props => props.theme.font.bold};
  }
`
export default {
  name: "pr-subtitle",
  components: {
    SubTitle
  },
  props: Props
}
</script>
